import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getFormattedDate, DATE_FORMAT_COMPACT_SLASH } from 'dateUtils';

export default function usePastTime() {
  const { t } = useTranslation();

  const humanizeTime = useCallback(
    (date: Date | string) => {
      const now = new Date();
      const then = new Date(date);

      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);

      const diffInSeconds = Math.floor((now.getTime() - then.getTime()) / 1000);
      const diffInMinutes = Math.floor(diffInSeconds / 60);
      const diffInHours = Math.floor(diffInMinutes / 60);
      const diffInDays = Math.floor(diffInHours / 24);

      if (diffInMinutes < 60) return t('minsAgo', { count: diffInMinutes });
      if (diffInHours < 24) return t('hoursAgo', { count: diffInHours });

      if (
        then.getDate() === yesterday.getDate() &&
        then.getMonth() === yesterday.getMonth() &&
        then.getFullYear() === yesterday.getFullYear()
      ) {
        return t('yesterday');
      }

      if (diffInDays <= 20) return t('daysAgo', { count: diffInDays + 1 });
      if (diffInDays <= 30) return '3 weeks ago';

      return getFormattedDate(date as Date, DATE_FORMAT_COMPACT_SLASH);
    },
    [t],
  );

  return useCallback(
    (date: Date | string) => humanizeTime(date),
    [humanizeTime],
  );
}
